import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {NotificationsPermissionDisplayEvent} from "../models/events/notifications-permission.display-event";
import {ACTION_TYPES} from "../consts";

export class NotificationsPermissionDisplayEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.notificationsPermissionDisplay;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NotificationsPermissionDisplayEvent;
  }
}
